(function(){
  if (window.__intBandRevealBooted) return;
  window.__intBandRevealBooted = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  var flown = {};
  function fly(band){
    var dy = window.innerHeight - band.getBoundingClientRect().top;
    if (dy < 120) dy = 120;
    band.style.transform = 'translateY(' + dy + 'px)';
    band.classList.add('sa-band-fly');
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        band.style.transform = 'translateY(0)';
        setTimeout(function(){
          band.classList.add('sa-band-in');
          band.classList.remove('sa-band-fly');
          band.style.removeProperty('transform');
        }, 950);
      });
    });
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){
        io.unobserve(en.target);
        flown[en.target.getAttribute('data-band-i')] = 1;
        fly(en.target);
      }
    });
  }, { rootMargin: '0px 0px -35% 0px' });
  function arm(grid){
    var bands = grid.querySelectorAll('li.sa-band');
    for (var i = 0; i < bands.length; i++){
      var b = bands[i];
      if (b.classList.contains('sa-band-armed')) continue;
      b.classList.add('sa-band-armed');
      b.setAttribute('data-band-i', i);
      if (flown[i]){ b.classList.add('sa-band-in'); }
      else { io.observe(b); }
    }
  }
  function init(){
    var grid = document.getElementById('sa_grid');
    if (!grid){ setTimeout(init, 300); return; }
    arm(grid);
    new MutationObserver(function(){ arm(grid); }).observe(grid, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
